var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-fail-message',[_vm._v("404 Ja so a Seitn gibt´s do ned...")])}
var staticRenderFns = []

export { render, staticRenderFns }